import React from "react";
import {
    Box,
    Heading,
    Text,
    Flex,
    Stack,
    Divider,
    Center,
    GridItem,
    Link,
    Grid,
} from "@chakra-ui/react";
import { CustomHead } from "components/custom-head";

import { Header } from "components/tweets-public/header";
import { Footer } from "components/tweets-public/footer";
import { getAllPosts, tools } from "controllers/seo";
import { QuestionAnswers } from "../../components/tweets-public/faq";

function ResourceItem({ tool, fontSize = "2xl" }) {

    let maxLength = 50;
    let title = tool?.params?.title;;

    // truncate
    if (title?.length > maxLength) {
        //trim the string to the maximum length
        title = title.substr(0, maxLength);
        //re-trim if we are in the middle of a word
        title = title.substr(0, Math.min(title?.length, title.lastIndexOf(" "))) + " ...";
    }

    return (
        <GridItem w="250px" display="flex" flexDir="column" >
            <Link href={tool?.params?.link}>
                <Flex h="150px" alignItems="center" justifyContent="center" bg="linear-gradient(180deg, #144461,#091E2B)" color="white" p={8} rounded="md">
                    <Heading textAlign="center" as="h3" fontSize={fontSize} fontWeight="800" lineHeight="lg">{title}</Heading>
                </Flex>
            </Link>
            <Text textAlign="left" mt={5}>{tool?.params?.description}</Text>
        </GridItem>
    )
}

// export default function Post() {
export default function Resources({ paths }) {

    let tweetHunterLink = "https://tweethunter.io?utm_source=resources&utm_term=resources";

    return (
        <Box maxW={1000} margin="auto" mb={10}>
            {/* <Navbar/> */}
            <CustomHead
                title={"Best of tools, resources and tips for X"}
                desc={"The best tools and resources to grow a X account."}
                url={"https://tweethunter.io/resources"}
            />
            <Header customLink={tweetHunterLink} />
            <Box maxW={800} margin="auto" p={4} mt={10}>
                <Center flexDir="column" gap={5} textAlign="center">
                    <Heading as="h1" fontWeight={800} fontSize="5xl" maxW="400px" >
                        Top Resources to Grow on X
                    </Heading>
                    <Text mt={10} fontWeight={800} fontSize="lg">This isn't a blog</Text>
                    <Text mt={10} fontWeight={400} fontSize="lg" maxW="600px" >It's a collection of actionable resources to help you get more X followers and monetize your audience.</Text>
                </Center>

                <Center mt={10} flexDir="column" textAlign="center">
                    <Divider maxW="200px" />
                    <Heading mt={10} fontWeight={600} as="h2" fontSize="2xl" maxW="600px" >🔨 The Toolbox</Heading>
                    <Text mt={2} fontWeight={400} fontSize="sm" maxW="600px">Free X mini-tools to help you grow</Text>
                    <Grid
                        mt={10}
                        templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
                        gap={{ base: "8", md: "12" }}
                    >
                        {
                            tools.map((tool, index) => (
                                <ResourceItem key={index} tool={{ params: tool }} />
                            ))
                        }
                    </Grid>
                </Center>

                <Center mt={10} flexDir="column" textAlign="center">
                    <Divider maxW="200px" />
                    <Heading mt={10} fontWeight={600} as="h2" fontSize="2xl" maxW="600px" >📚 Resources</Heading>
                    <Text mt={2} fontWeight={400} fontSize="sm" maxW="600px">A variety of X-focused learning and inspiration material</Text>
                    <Grid
                        mt={10}
                        templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
                        gap={{ base: "8", md: "12" }}
                    >
                        {
                            paths.filter(x => x?.params?.isResource && !x?.params?.isCopy)
                                .sort((a, b) => new Date(b.params.dateCreated).getTime() - new Date(a.params.dateCreated).getTime())
                                .slice(0, 12)
                                .map((tool, index) => (
                                    // paths.map((tool, index) => (
                                    <ResourceItem key={index} tool={tool} fontSize="xl" />
                                ))
                        }
                    </Grid>
                </Center>

            </Box>
            <Footer id={"resources"} url={"https://tweethunter.io/resources"} title={"Top resources from the Tweet Hunter's team"} description={"Find here all our resources to help you take the most out of your X experience."} paths={paths} />

            <QuestionAnswers />
        </Box>
    );
}


export async function getStaticProps() {

    let paths = await getAllPosts();

    // console.log(paths);

    return {
        props: {
            paths,
        }
    }
}